export default __webpack_public_path__ + "static/1-55f65d0149b057129202378631b7b0bc.png";